import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryShowcase() {
  return (
    <section id="category-section" className="py-12 md:py-16">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-3">
            剧集分类
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            涵盖国产、港台、日韩、欧美等多种类型，满足你的所有追剧需求
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/60 hover:border-primary-500/30 hover:bg-background-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-primary-500/10 text-primary-400 group-hover:bg-primary-500 group-hover:text-background-50 dark:group-hover:text-foreground-950 transition-all duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <div className="text-center">
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors duration-300 whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 hidden sm:block line-clamp-1">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}